webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("+prg");
module.exports = __webpack_require__("lVK7");


/***/ }),

/***/ "2u/B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KKCountdown = function () {
  _createClass(KKCountdown, [{
    key: 'countTo',
    get: function get() {
      return this._countTo;
    },
    set: function set(value) {
      console.log('-> countTo: ', value);
      this._countTo = value;
    }
  }, {
    key: 'container',
    get: function get() {
      return this._container;
    },
    set: function set(value) {
      console.log('-> container: ', value);
      this._container = value;
    }
  }]);

  function KKCountdown() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, KKCountdown);

    this.defaults = {
      dayText: 'day ',
      daysText: 'days ',
      hourText: 'hour ',
      hoursText: 'hours ',
      minuteText: ':',
      minutesText: ':',
      secondText: '',
      secondsText: '',

      textAfterCount: '---',
      oneDayClass: '',
      displayDays: true,
      displayZeroDays: true,
      customClass: '',
      afterFinish: function afterFinish() {},
      warnSeconds: 60,
      warnClass: '',

      containerClass: 'kkcd-container',
      secondsClass: 'kkcd-seconds',
      minutesClass: 'kkcd-minutes',
      hoursClass: 'kkcd-hours',
      daysClass: 'kkcd-days',

      secondsTextClass: 'kkcd-seconds-text',
      minutesTextClass: 'kkcd-minutes-text',
      hoursTextClass: 'kkcd-hours-text',
      daysTextClass: 'kkcd-days-text'
    };
    this.seconds = 0;
    this.minutes = 0;
    this.hours = 0;
    this.days = 0;
    this.loop = null;

    this._container = null;
    this._countTo = null;

    this.setOptions(options);
  }

  KKCountdown.prototype.setOptions = function setOptions(options) {
    this.options = Object.assign({}, this.defaults, options);
    console.log('=> options: ', this.options);
  };

  KKCountdown.prototype.stop = function stop() {
    clearInterval(this.loop);
  };

  KKCountdown.prototype.start = function start() {
    var _this = this;

    var countdownType = _typeof(this.countTo);

    console.log('-> this.countTo: ', countdownType);

    switch (countdownType) {
      case 'number':
        console.log('===> GO NUMBER');
        this.seconds = this.countTo;
        this.countdownNumber();
        this.loop = setInterval(function () {
          _this.countdownNumber();
        }, 1000);
        break;

      default:
        this.countdown();
        this.loop = setInterval(function () {
          _this.countdown();
        }, 1000);
        break;
    }

    console.log('================');
  };

  KKCountdown.prototype.finish = function finish() {
    this.stop();
    this.container.innerHTML = this.prepareFinishString();
    this.options.afterFinish.call(this);
  };

  KKCountdown.prototype.countdownNumber = function countdownNumber() {
    this.seconds -= 1;
    this.container.innerHTML = this.prepareCoundownNumberString();

    if (this.seconds <= 0) {
      this.finish();
      return false;
    }

    return this;
  };

  KKCountdown.prototype.countdown = function countdown() {
    var now = Math.floor(new Date().getTime() / 1000);
    var dateTo = Math.floor(new Date(this.countTo).getTime() / 1000);
    var count = dateTo - now;

    if (count <= 0) {
      this.finish();
      return false;
    }

    this.seconds = this.fixNumber(count % 60);
    count = Math.floor(count / 60);
    this.minutes = this.fixNumber(count % 60);
    count = Math.floor(count / 60);
    this.hours = this.fixNumber(count % 24);
    count = Math.floor(count / 24);
    this.days = count;

    this.container.innerHTML = this.prepareCountdownString();

    return this;
  };

  KKCountdown.prototype.formatText = function formatText(number, text) {
    return number > 1 ? this.options[text + 'sText'] : this.options[text + 'Text'];
  };

  KKCountdown.prototype.checkLastMoment = function checkLastMoment() {
    return parseInt(this.days, 10) === 0 && parseInt(this.hours, 10) === 0 && parseInt(this.minutes, 10) === 0;
  };

  KKCountdown.prototype.prepareCountdownString = function prepareCountdownString() {
    var _options = this.options,
        containerClass = _options.containerClass,
        secondsClass = _options.secondsClass,
        minutesClass = _options.minutesClass,
        hoursClass = _options.hoursClass,
        daysClass = _options.daysClass,
        secondsTextClass = _options.secondsTextClass,
        minutesTextClass = _options.minutesTextClass,
        hoursTextClass = _options.hoursTextClass,
        daysTextClass = _options.daysTextClass,
        oneDayClass = _options.oneDayClass,
        displayDays = _options.displayDays,
        displayZeroDays = _options.displayZeroDays,
        customClass = _options.customClass,
        warnSeconds = _options.warnSeconds,
        warnClass = _options.warnClass;


    var secondsText = '<span class="' + secondsTextClass + '">' + this.formatText(this.seconds, 'second') + '</span>';
    var seconds = '<span class="' + secondsClass + '">' + this.seconds + secondsText + '</span>';

    var minutesText = '<span class="' + minutesTextClass + '">' + this.formatText(this.minutes, 'minute') + '</span>';
    var minutes = '<span class="' + minutesClass + '">' + this.minutes + minutesText + '</span>';

    var hoursText = '<span class="' + hoursTextClass + '">' + this.formatText(this.hours, 'hour') + '</span>';
    var hours = '<span class="' + hoursClass + '">' + this.hours + hoursText + '</span>';

    var daysText = '<span class="' + daysTextClass + '">' + this.formatText(this.days, 'day') + '</span>';
    var days = '<span class="' + daysClass + '">' + this.days + daysText + '</span>';

    return '\n      <span class="\n        ' + containerClass + ' \n        ' + (oneDayClass && this.days < 1 ? oneDayClass : '') + ' \n        ' + customClass + ' \n        ' + (warnSeconds && this.checkLastMoment() && this.seconds <= warnSeconds ? warnClass : '') + '\n      ">\n        ' + (displayDays ? !displayZeroDays && this.days === 0 ? '' : days : '') + hours + minutes + seconds + '\n      </span>\n    ';
  };

  KKCountdown.prototype.prepareCoundownNumberString = function prepareCoundownNumberString() {
    var _options2 = this.options,
        secondsClass = _options2.secondsClass,
        containerClass = _options2.containerClass,
        customClass = _options2.customClass,
        warnSeconds = _options2.warnSeconds,
        warnClass = _options2.warnClass;


    var seconds = '<span class="' + secondsClass + '">' + this.seconds + '</span>';

    return '\n      <span class="\n        ' + containerClass + '\n        ' + customClass + ' \n        ' + (warnSeconds && this.checkLastMoment() && this.seconds <= warnSeconds ? warnClass : '') + '\n      ">\n        ' + seconds + '\n      </span>\n    ';
  };

  KKCountdown.prototype.prepareFinishString = function prepareFinishString() {
    var _options3 = this.options,
        containerClass = _options3.containerClass,
        textAfterCount = _options3.textAfterCount;


    return '<span class="' + containerClass + '">' + textAfterCount + '</span>';
  };

  KKCountdown.prototype.fixNumber = function fixNumber(number) {
    return number >= 10 ? number : '0' + number;
  };

  return KKCountdown;
}();

/* harmony default export */ __webpack_exports__["a"] = (KKCountdown);

/***/ }),

/***/ "GcMe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lVK7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__("OEdS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prismjs_themes_prism_coy_css__ = __webpack_require__("tNeA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prismjs_themes_prism_coy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prismjs_themes_prism_coy_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_normalize_css__ = __webpack_require__("uMhA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gridlex_docs_gridlex_min_css__ = __webpack_require__("O4vq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gridlex_docs_gridlex_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_gridlex_docs_gridlex_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_index__ = __webpack_require__("2u/B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_css__ = __webpack_require__("GcMe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style_css__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }











var Demo = function () {
  function Demo() {
    _classCallCheck(this, Demo);

    console.log('==> DEMO <==');

    this.demoStart();
  }

  Demo.prototype.demoStart = function demoStart() {
    var countdown = new __WEBPACK_IMPORTED_MODULE_5__src_index__["a" /* default */]({
      textAfterCount: '',
      oneDayClass: 'kk-test',
      displayDays: true,
      displayZeroDays: true,
      customClass: 'kk-custom',
      afterFinish: function afterFinish() {},
      warnSeconds: 60,
      warnClass: 'kk-warn'
    });
    countdown.container = document.getElementById('app-1');
    countdown.countTo = __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(10, 'd');
    countdown.start();

    document.getElementById('app-1-start').addEventListener('click', function () {
      countdown.start();
    });

    document.getElementById('app-1-stop').addEventListener('click', function () {
      countdown.stop();
    });

    var countdown1 = new __WEBPACK_IMPORTED_MODULE_5__src_index__["a" /* default */]();
    countdown1.container = document.getElementById('app-2');
    countdown1.countTo = '2018-12-01T12:00:00.00';
    countdown1.start();

    var countdown2 = new __WEBPACK_IMPORTED_MODULE_5__src_index__["a" /* default */]({
      textAfterCount: '',
      oneDayClass: 'kk-test',
      customClass: 'kk-custom',
      afterFinish: function afterFinish() {
        console.log('===> FINISH!!!');
      },
      warnSeconds: 60,
      warnClass: 'kk-warn'
    });
    countdown2.container = document.getElementById('app-3');
    countdown2.countTo = 65;
    countdown2.start();
  };

  return Demo;
}();

window.onload = function () {
  new Demo();
};

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ })

},[0]);


// WEBPACK FOOTER //
// app.6a9adfbb.js